import type { UserRole } from './generated/gql-enums';

export const USER_ROLE_ADMIN = 'ADMIN' satisfies UserRole;
export const USER_ROLE_ADMIN_CSA = 'ADMIN_CSA' satisfies UserRole;
export const USER_ROLE_ADVISOR = 'ADVISOR' satisfies UserRole;
export const USER_ROLE_ASSISTANT = 'ASSISTANT' satisfies UserRole;
export const USER_ROLE_CLIENT = 'CLIENT' satisfies UserRole;
export const USER_ROLE_CSA = 'CSA' satisfies UserRole;
export const USER_ROLE_NON_ADVISORY_USER = 'NON_ADVISORY_USER' satisfies UserRole;
export const USER_ROLE_READ_ONLY_ADMIN = 'READ_ONLY_ADMIN' satisfies UserRole;

export const ALL_USER_ROLES = [
  USER_ROLE_ADMIN,
  USER_ROLE_ADMIN_CSA,
  USER_ROLE_ADVISOR,
  USER_ROLE_ASSISTANT,
  USER_ROLE_CLIENT,
  USER_ROLE_CSA,
  USER_ROLE_NON_ADVISORY_USER,
  USER_ROLE_READ_ONLY_ADMIN,
] satisfies UserRole[];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [USER_ROLE_ADMIN]: 'Admin',
  [USER_ROLE_ADMIN_CSA]: 'Admin CSA',
  [USER_ROLE_ADVISOR]: 'Advisor',
  [USER_ROLE_ASSISTANT]: 'Assistant',
  [USER_ROLE_CLIENT]: 'Client',
  [USER_ROLE_CSA]: 'CSA',
  [USER_ROLE_NON_ADVISORY_USER]: 'Non-Advisory User',
  [USER_ROLE_READ_ONLY_ADMIN]: 'Read Only Admin',
};
